var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "check-box-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(-357 -565)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "color-first",
    id: "Path_14907",
    "data-name": "Path 14907",
    transform: "translate(357 565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 31.5 31.5 L 0.5 31.5 L 0.5 0.5 L 31.5 0.5 L 31.5 31.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 31 L 31 31 L 31 1 L 1 1 M 0 0 L 32 0 L 32 32 L 0 32 L 0 0 Z",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ultralight-S",
    transform: "translate(337.224 622.467)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "color-sec",
    id: "Path_14755",
    "data-name": "Path 14755",
    d: "M31.943-32.318l-5.906-7.668.586-.753,5.32,6.8L44.928-50.616l.586.814Z",
    fill: "buttonText"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.c9e4798d6266285b9fc66d37aeb482c3.svg";
export { ForwardRef as ReactComponent };